<template lang="pug">
div
  .d-flex.justify-space-between.align-center.mb-2.mr-xl-10
    .text-sm.neutral500--text Outstanding balance
  .text-2xl.font-semibold.mb-2
    span.neutral500--text(v-if="displayDueAmount === null") {{ 0 | displayPrice }} 
    span(v-else :class="[displayDueAmount > 0 ? 'neutral700--text' : 'success500--text']") {{ displayDueAmount | displayPrice }}
  .text-sm.mb-8.danger500--text(v-if="isQuotation") Convert your quotation to a purchase order to begin payment tracking
  .text-sm.mb-8.danger500--text(v-if="!isQuotation && status === 'draft'") Update item price & quantity to start viewing balance.
  div.to-bottom.mb-8
    v-btn.button-sm.neutral700--text.mr-2(v-if="showRecordPaymentButton" outlined @click="openRecordPaymentDialog = true") Record payment
    v-menu(v-if="showPaymentRecordList" offset-x left :close-on-content-click="false")
      template(v-slot:activator='{ on, attrs }')
        v-btn.button-xs.neutral700--text.underline(text v-on="on") {{ paymentRecords.totalCount }} {{ 'payment' | pluralize({ count: paymentRecords.totalCount }) }} recorded
      v-card.rounded-lg.pa-2
        v-data-table(:headers="paymentRecords.headers" :items="paymentRecords.data" hide-default-footer disable-sort)
          template(v-slot:item.paid_date='{ item }')
            div {{ item.paid_date | convertToDateOnly }}
          template(v-slot:item.amount='{ item }')
            div {{ item.amount | displayPrice }}
          template(v-slot:item.document='{ item }')
            v-btn.button-sm.font-semibold.underline(v-if="item.document" text @click="handleViewAttachment(item)") View
          template(v-slot:item.edit='{ item }')
            v-btn.button-sm.font-semibold.underline(text @click="handleEdit(item)") Edit
  .dialogs
    record-payment-dialog(v-if="openRecordPaymentDialog" :open.sync="openRecordPaymentDialog" :parentDocumentData="parentData" :parentPaymentData="selectedPayment" :dueAmount="dueAmount" :selectedDocument="selectedDocument" @updated="handleUpdateRecordPayment" @close="selectedPayment = null")
    view-image-dialog(v-if="openViewImageDialog" :open.sync="openViewImageDialog" :image="selectedImage" @closed="selectedImage = null")
</template>
    
<script>
import { mapGetters, mapActions } from 'vuex'
import RecordPaymentDialog from '@/components/clinic/dialogs/purchasehub/RecordPaymentDialog.vue'
import ViewImageDialog from '@/components/dialogs/ViewImageDialog.vue'

export default {
  components: {
    RecordPaymentDialog, ViewImageDialog
  },
  props: {
    parentData: {
      type: Object,
      default: null
    },
    selectedDocument: {
      type: Object,
      required: true
    },
    dueAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      openRecordPaymentDialog: false,
      openViewImageDialog: false,
      selectedImage: null,
      paymentRecords: {
        isFetching: false,
        isError: false,
        data: [],
        totalCount: 0,
        headers: [
          { text: 'Date', value: 'paid_date' },
          { text: 'Amount', value: 'amount' },
          { text: 'Payment method', value: 'payment_method' },
          { text: 'Attachment', value: 'document' },
          { text: 'Remarks', value: 'remarks' },
          { text: '', value: 'edit' },
        ]
      },
      selectedPayment: null
    }
  },
  mounted () {
    if (this.selectedDocument.id !== 'quotation' && this.parentData) {
      this.fetchRecordPayments()
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    parentId () {
      return this.parentData?.id
    },
    showPaymentRecordList () {
      return this.selectedDocument.id !== 'quotation' && this.status !== 'draft' && this.paymentRecords.totalCount > 0
    },
    showRecordPaymentButton () {
      if (this.selectedDocument.id === 'quotation') return false

      return this.status === 'active'
    },
    status () {
      return this.parentData?.request_status || this.parentData?.order_status
    },
    displayDueAmount () {
      if (this.selectedDocument.id !== 'quotation' && this.status !== 'draft') return this.dueAmount

      return null
    },
    isQuotation () {
      return this.selectedDocument.id === 'quotation'
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchRecordPayments () {
      try {
        this.paymentRecords.isFetching = true
        const params = {
          page_size: -1,
        }
        if (this.selectedDocument.id === 'purchase-order' || this.selectedDocument.id === 'stock-transfer') {
          params.order = this.parentId
        } else {
          params.invoice = this.parentId
        }
        const { data } = await this.$axios.get(`/purchases/${this.company.slug}/payments`, { params })
        if (data?.count > 0) {
          this.paymentRecords.data = data.results
          this.paymentRecords.totalCount = data.count
        }
      } catch (error) {
        this.paymentRecords.isError = true
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.paymentRecords.isFetching = false
      }
    },
    handleUpdateRecordPayment () {
      this.fetchRecordPayments()
      this.$emit('updated')
    },
    handleViewAttachment (item) {
      this.selectedImage = item.document.file
      this.openViewImageDialog = true
    },
    handleEdit (item) {
      this.selectedPayment = item
      this.openRecordPaymentDialog = true
    }
  },
}
</script>

<style scoped>
.to-bottom {
  position: absolute;
  bottom: 0
}
</style>